import React, { useState } from 'react';

const LoginModal = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [showMoreWallets, setShowMoreWallets] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const toggleMoreWallets = () => {
    setShowMoreWallets((prev) => !prev);
  };

  return (
    isOpen && (
      <div className="login-modal-overlay">
        <div className="login-modal-content">
          <button className="login-modal-close" onClick={closeModal}>
            &times;
          </button>
          <h2 className="heading-log">Login or Sign Up</h2>
          <input
            type="email"
            placeholder="your@gmail.com"
            className="login-input"
          />
          <button className="login-submit">Submit</button>

          <div className="login-divider">or</div>
          <button className="login-submit" onClick={toggleMoreWallets}>
            More Wallet
          </button>

          {/* Conditionally Render Wallet Buttons */}
          {showMoreWallets && (
            <>
              <button className="login-wallet">
                <img src="wallet-1.png" className="wallet-icon" alt="Torus" />
                Torus
              </button>
              <button className="login-wallet">
                <img src="wallet-2.png" className="wallet-icon" alt="Ledger" />
                Ledger
              </button>
              {/* Uncomment to add more wallets */}
              {/* <button className="login-wallet">
                <img src="wallet-3.png" className="wallet-icon" alt="Solflare" />
                Solflare
              </button>
              <button className="login-wallet">
                <img src="wallet-4.png" className="wallet-icon" alt="Wallet Connect" />
                Wallet Connect
              </button> */}
              <button className="login-wallet">
                <img src="wallet-5.png" className="wallet-icon" alt="Wallet Connect" />
                Wallet Connect
              </button>
              <button className="login-wallet">
                <img src="wallet-6.png" className="wallet-icon" alt="Wallet Connect" />
                Wallet Connect
              </button>
            </>
          )}
        </div>
      </div>
    )
  );
};

export default LoginModal;
